import getApp from "./qapp";
import 'bootstrap/js/src/dropdown';
import React from 'react';

class QlikFilter extends React.Component {
  constructor(props) {
    super(props);

    this.getList = getApp.then(app => {
      return app.createList({  
        qDef: {  
          qFieldDefs: [this.props.field],
          qSortCriterias: [{qSortByAscii: 1}] 
        },
        qShowAlternatives: true,
        qAutoSortByState: {qDisplayNumberOfRows: 1}
      });
    });

    this.state = {
      offset: 0,
      data: [],
      size: 0 
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.getList.then(list => {
      list.Validated.bind(() => {
        this.getLayout();
        this.getListObjectData();
      });
    });
    
    $(this.refs['dropdown']).on({
      'show.bs.dropdown': () => { this.beginSelections(); },
      'hide.bs.dropdown': () => { this.endSelections(); $(this.refs['search']).val(''); $(this.refs['scrollable']).scrollTop(0); }
    });
  }
  componentWillUnmount() {
    
  }

  getListObjectData() {
    this.getList.then(list => {
      list.getListObjectData("/qListObjectDef", [{
        qTop: this.state.offset, 
        qLeft: 0, 
        qHeight: 10, 
        qWidth: 1
      }]).then(listObjectData => {
        this.setState({data: listObjectData[0].qMatrix});
      });
    });
  }

  searchListObjectFor(string) {
    this.getList.then(list => {
      list.searchListObjectFor("/qListObjectDef", string);
    });
  }

  getLayout() {
    this.getList.then(list => {
      list.getLayout().then(layout => {
        this.setState({size: layout.qListObject.qSize.qcy});
      })
    });
  }

  beginSelections() {
    this.getList.then(list => {
      list.beginSelections(['/qListObjectDef']);
    });
  }

  endSelections() {
    this.getList.then(list => {
      list.endSelections(true);
    });
  }

  selectRow(elnum) {
    this.getList.then(list => {
      list.selectListObjectValues('/qListObjectDef', [elnum], true);
    });
  }

  render() {
    return (
      <div className="dropdown" ref="dropdown">
        <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {this.props.name}
        </button>
        <div className="dropdown-menu" style={{width: '140px'}} aria-labelledby="dropdownMenuButton">
          <form>
            <input type="text" style={{height: `calc(${this.props.rowHeight} * 1.5`}} placeholder="Search..." ref="search" onChange={this.handleChange}/>
            <div className="scrollable" style={{maxHeight: `calc(${this.props.rowHeight} * 10)`, overflow: 'auto'}} onScroll={this.handleScroll} ref="scrollable">
              <ul style={{marginBottom: 0}} ref="list">
                {this.state.data.map((row) => {
                  return <li key={row[0].qElemNumber} className={`dropdown-item ${row[0].qState}`} style={{height: this.props.rowHeight}} data-elem-number={row[0].qElemNumber} onClick={this.handleClick}>
                    <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', pointerEvents: 'none'}}>{row[0].qText}</div>
                  </li>; 
                })}
              </ul>
              <div className="scroll-allowance" style={{height: `calc(${this.props.rowHeight} * (${this.state.size} - 10))`}}></div>
            </div>
          </form>
        </div>
      </div>
    )
  }
  handleChange(event) {
    $(this.refs['scrollable']).scrollTop(0);
    this.setState({offset: 0});
    this.searchListObjectFor($(event.target).val());
  }
  handleScroll(event) {
    $(this.refs['list']).css('transform', `translateY(${$(this.refs['scrollable']).scrollTop()}px)`);
    this.setState({offset: Math.floor($(event.target).scrollTop() / $(this.refs['list']).find('li').outerHeight())});
    this.getListObjectData();
  }
  handleClick(event) {
    this.selectRow($(event.target).data('elem-number'));
  }
}
QlikFilter.defaultProps = {rowHeight: '20px'};

export default QlikFilter;


// WEBPACK FOOTER //
// ./QlikFilter.js